import {ReactNode} from "react";

export default function Section({ children, className, id }: { children: ReactNode, className?: string, id: string }) {
    return <>
        <div id={id} className={`pt-24 sm:pt-32 ${className || ''}`}>
            {children}
        </div>
    </>
}